import { defineComponent, inject, ref, computed, provide, openBlock, createElementBlock, normalizeClass, createElementVNode, toDisplayString, createCommentVNode, createBlock, withCtx, createVNode, unref, renderSlot } from "vue";
import HelpCircleIcon from "../../assets/icons/help-circle.svg.js";
import { FORM_KEY } from "../form/type.js";
import Tooltip from "../tooltip/Tooltip.vue.js";
import { FORM_CONTROL_KEY } from "./type.js";
const _hoisted_1 = { class: "form-control__label" };
const _hoisted_2 = { class: "form-control__text" };
const _hoisted_3 = {
  key: 0,
  class: "form-control__required"
};
const _hoisted_4 = { class: "form-control__help-icon" };
const _hoisted_5 = { class: "form-control__content" };
const _hoisted_6 = { class: "form-control__input" };
const _hoisted_7 = {
  key: 0,
  class: "form-control__error"
};
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "FormControl",
  props: {
    label: {},
    name: {},
    helpText: {},
    required: { type: Boolean },
    hint: {},
    errorMessage: {},
    size: { default: "sm" },
    horizontal: { type: Boolean, default: false }
  },
  setup(__props) {
    const props = __props;
    const { formContext } = inject(FORM_KEY, null) || {};
    const [model] = formContext ? formContext.value.defineField(props.name ?? "") : [ref()];
    const hasError = computed(() => {
      return !!props.errorMessage || !!formContext?.value.errors.value[props.name ?? ""];
    });
    const message = computed(() => {
      return props.errorMessage || formContext?.value.errors.value[props.name ?? ""];
    });
    const hint = computed(() => props.hint);
    provide(FORM_CONTROL_KEY, {
      size: props.size,
      hasError,
      hint,
      model
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(["form-control", { "form-control--horizontal": __props.horizontal }])
      }, [
        createElementVNode("div", _hoisted_1, [
          createElementVNode("span", _hoisted_2, toDisplayString(__props.label), 1),
          __props.required ? (openBlock(), createElementBlock("span", _hoisted_3, " * ")) : createCommentVNode("", true),
          __props.helpText ? (openBlock(), createBlock(Tooltip, {
            key: 1,
            content: __props.helpText,
            position: "top"
          }, {
            default: withCtx(() => [
              createElementVNode("span", _hoisted_4, [
                createVNode(unref(HelpCircleIcon))
              ])
            ]),
            _: 1
          }, 8, ["content"])) : createCommentVNode("", true)
        ]),
        createElementVNode("div", _hoisted_5, [
          createElementVNode("div", _hoisted_6, [
            renderSlot(_ctx.$slots, "default", {}, void 0, true)
          ]),
          hasError.value ? (openBlock(), createElementBlock("div", _hoisted_7, toDisplayString(message.value), 1)) : createCommentVNode("", true)
        ])
      ], 2);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=FormControl.vue2.js.map
